import script from "./UserHackathons.vue?vue&type=script&setup=true&lang=js"
export * from "./UserHackathons.vue?vue&type=script&setup=true&lang=js"

import "./UserHackathons.vue?vue&type=style&index=0&id=3deb8163&lang=scss&scoped=true"
script.__scopeId = "data-v-3deb8163"

export default script